export default "__VITE_ASSET__D1o4$bsv__"